import type { FlexProps } from '@chakra-ui/react';
import { Flex, Hide, Show, Text } from '@chakra-ui/react';
import React from 'react';

import { PartnerLinks } from './PartnerLinks';
import { FooterLinkList } from './FooterLinkList';
import { AddNetworkButton } from './AddNetwork';

const CopyrightByCratD2C = () => {
  return (
    <Text as={'span'} fontWeight={400} fontSize={{ base: '12px', sm: '14px' }}>
      Copyright © {new Date().getFullYear()} CratD2C
    </Text>
  );
};

const containerProps: FlexProps = {
  as: 'footer',
  px: { base: '20px', sm: '40px', md: '77.5px' },
  py: { base: '20px', lg: '44px' },
  minW: '100%',
  alignItems: { base: 'center', lg: 'flex-end' },
  position: { base: 'static', lg: 'absolute' },
  bottom: 0,
};

export const Footer = React.memo(() => {
  return (
    <>
      <Hide above="lg">
        <Flex {...containerProps} gap="30px" flexDirection="column" justifyContent="center">
          <Flex gap="15px" alignItems="center" flexDirection="column">
            <AddNetworkButton />
            <CopyrightByCratD2C />
          </Flex>
          <PartnerLinks />
          <FooterLinkList />
        </Flex>
      </Hide>
      <Show above="lg">
        <Flex {...containerProps} justifyContent="space-between">
          <Flex gap="30px" alignItems="center">
            <Hide above="1180px">
              <Flex gap="20px" alignItems="flex-start" flexDirection="column" position="absolute" bottom={12}>
                <AddNetworkButton />
                <CopyrightByCratD2C />
              </Flex>
            </Hide>
            <Show above="1180px">
              <CopyrightByCratD2C />
              <AddNetworkButton />
            </Show>
          </Flex>
          <Flex gap="30px" alignItems="center">
            <PartnerLinks />
            <FooterLinkList />
          </Flex>
        </Flex>
      </Show>
    </>
  );
});
